import { Badge, Modal } from "flowbite-react";
import { useContext } from "react";
import { IAppContextState, AppContext } from "../../../App";
import { Link } from "react-router-dom";
import { GoptsGallery } from "../../../components/image-gallery/gopts-gallery";

export const GoptsModalData = () => {
  const { goptsModalState } = useContext<IAppContextState | any>(AppContext);
  const [isOpenGoptsModal, setOpenGoptsModal] = goptsModalState;
  return (
    <Modal
      size={"5xl"}
      position={"top-center"}
      show={isOpenGoptsModal}
      onClose={() => setOpenGoptsModal(false)}
    >
      <Modal.Header>
        GOPTS - Garments Order & Production Tracking System
      </Modal.Header>
      <Modal.Body>
        <div className="flex flex-wrap">
          <div className="md:w-[50%] w-full pe-2">
            <GoptsGallery />
          </div>
          <div className="md:w-[50%] w-full ps-2 md:mt-0 mt-6 flex flex-col justify-between">
            <div>
              <h3 className="font-bold text-xl">
                Project name: <span className="text-blue-800">GOPTS</span>
              </h3>
              <p className="mt-4 mb-2 text-md text-[15px]">Tech used:</p>
              <div className="flex flex-wrap">
                <Badge color="red" className="me-2 my-1">
                  React
                </Badge>
                <Badge color="green" className="me-2 my-1">
                  MongoDB
                </Badge>
                <Badge color="gray" className="me-2 my-1">
                  ExpressJS
                </Badge>
                <Badge color="green" className="me-2 my-1">
                  NodeJS
                </Badge>
                <Badge color="yellow" className="me-2 my-1">
                  javaScript
                </Badge>
                <Badge color="red" className="me-2 my-1">
                  Firebase Auth
                </Badge>
                <Badge color="blue" className="me-2">
                  TailwindCss
                </Badge>
              </div>
              <div className="mt-5 mb-2 ">
                <p className="font-semibold">Description:</p>
                <div className="text-[15px]">
                  <p>
                    This application provides a user-friendly interface for
                    managing garment orders and production. It interacts with
                    the backend server to track orders, manage products, monitor
                    production, and handle user accounts efficiently.
                  </p>
                  <ul className="list-disc ms-5 mt-4">
                    <li>
                      Admin controls all the user, orders and products so that
                      everyone stay protected.
                    </li>
                    <li>
                      Easy steps to buy any garments products for buyers and
                      easy management system.
                    </li>
                    <li>
                      Manage own products as a manager and handle the product
                      orders easily with UI rich dashboard.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="mt-10">
              <Link
                target="_blank"
                rel="noreferrer"
                to="https://gopts.netlify.app/"
                className="text-blue-700 hover:text-blue-800 hover:underline"
              >
                Go to GOPTS
              </Link>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
